import type * as React from 'react';

import { Styled } from './topic-page-header.styles';

export type TopicPageHeaderType = {
  evergreenTitle: string;
  introduction: string[];
};

export const TopicPageHeader: React.FC<TopicPageHeaderType> = ({
  evergreenTitle,
  introduction,
}) => (
  <header>
    <Styled.Hero size="small" forwardedAs="h1">
      {evergreenTitle}
    </Styled.Hero>
    {introduction?.map((paragraphText, index) => (
      <Styled.BodyCopy key={index} size="large">
        {paragraphText}
      </Styled.BodyCopy>
    ))}
  </header>
);
